import React from 'react';
import PropTypes from 'prop-types';


function TreeSelectItemContent({content}) {

    if (typeof content === 'function') {

        return content();
    }

    return content;
}


TreeSelectItemContent.propTypes = {
    content: PropTypes.oneOfType(
        [
            PropTypes.element,
            PropTypes.func,
            PropTypes.string
        ]
    ).isRequired
};

TreeSelectItemContent.defaultProps = {};


export default TreeSelectItemContent;
